import { Hidden } from "@material-ui/core";
import React from "react";

export default function MainFooter() {
    return (
        <>
            <footer className="pageFooter">
                <div className="container">
                    <div className="row">
                        <div className="col-md-2 col-6">
                            <h3 className="footerHeading">Product</h3>
                            <a className="footerLink" href="/pricing">
                                Pricing
                            </a>
                            <a className="footerLink" href="/features">
                                Why us
                            </a>
                        </div>
                        <div className="col-md-2 col-6 mt-lg-0">
                            <h3 className="footerHeading">Company</h3>
                            <a className="footerLink" href="/about-us">
                                About
                            </a>
                            <a className="footerLink" href="#">
                                Newsroom
                            </a>
                            <a className="footerLink" href="#">
                                Career
                            </a>
                            <a className="footerLink" href="#">
                                Contact us
                            </a>
                        </div>
                        <div className="col-md-2 col-6 mt-4 mt-lg-0">
                            <h3 className="footerHeading">Customer</h3>
                            <a className="footerLink" href="#">
                                Customer stories
                            </a>
                            <a className="footerLink" href="/testimonial">
                                Testimonials
                            </a>
                        </div>
                        <div className="col-md-2 col-6 mt-4 mt-lg-0">
                            <h3 className="footerHeading">Resources</h3>
                            <a
                                className="footerLink"
                                target="_blank"
                                href="https://blog.ulalive.com/"
                            >
                                Blog
                            </a>
                            <a className="footerLink" href="#">
                                Help & Support
                            </a>
                            <a className="footerLink" href="#">
                                Brand asset
                            </a>
                            <a className="footerLink" href="#">
                                FAQ
                            </a>
                        </div>
                        <div className="col-lg-4 mt-4 mt-lg-0">
                            <p className="footerLink mb-0">
                                Subscribe newsletter to get information, latest
                                news and other interesting offers about ulalive
                            </p>
                            <iframe
                                id="news"
                                src="https://cdn.forms-content.sg-form.com/cceca766-ee53-11ec-92df-da7f2d5f7b7d"
                                scrolling="no"
                                height={300}
                            />
                            {/* <div data-tf-widget="CWp2aMaO"></div> */}
                            {/* <form action="">
                                <div className="inputContainer">
                                    <img className="inputIcon" src={`${process.env.PUBLIC_URL}/img/input-icon.svg`} alt="" />
                                    <input
                                        className="footerInput"
                                        type="email"
                                        name=""
                                        id=""
                                        placeholder="Your email"
                                    />
                                    <button>
                                        <img src={`${process.env.PUBLIC_URL}/img/button-icon.svg`} alt="" />
                                    </button>
                                </div>
                            </form> */}
                            <div className="socialLinks mt-4">
                                <a
                                    target="_blank"
                                    href="https://www.youtube.com/channel/UCLSQBb5ATb1w22op1E9nipg"
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/img/youtube-icon.svg`}
                                        alt=""
                                    />
                                </a>
                                <a
                                    target="_blank"
                                    href="https://linkedin.com/company/ulalive"
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/img/linked-icon.svg`}
                                        alt=""
                                    />
                                </a>
                                <a
                                    target="_blank"
                                    href="https://twitter.com/ulalive"
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/img/twitter-icon.svg`}
                                        alt=""
                                    />
                                </a>
                                <a
                                    target="_blank"
                                    href="https://www.instagram.com/ulaliveco/"
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/img/instagram-icon.svg`}
                                        alt=""
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="copyRight">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 mt-2 mt-lg-0 text-center">
                            <p className="copyrightText">
                                Copyright © 2023 | Ulalive Inc.
                            </p>
                        </div>
                        <Hidden implementation="js" only={["sm", "xs"]}>
                            <div
                                className="col-lg-12"
                                style={{ position: "relative", marginTop: -40 }}
                            >
                                <a href="/terms">Terms</a>
                                <a href="/privacy">Privacy</a>
                            </div>
                        </Hidden>
                        <Hidden implementation="js" only={["lg", "md", "xl"]}>
                            <div className="col-lg-12">
                                <a href="/terms">Terms</a>
                                <a href="/privacy">Privacy</a>
                            </div>
                        </Hidden>
                    </div>
                </div>
            </div>
        </>
    );
}
